import React from "react";
import { Link } from "react-router-dom";
import { getExperienceYears } from "../config/dates";
import "./Home.css";

const Home: React.FC = () => {
  const experienceYears = getExperienceYears();
  return (
    <div className="home">
      <section className="about">
        <div className="container">
          <ul className="about-list">
            <li>I am Alec Potluri.</li>
            <li>Idempotence is king.</li>
            <li>{experienceYears.DEVOPS_START_DATE} years DevOps/SRE/SDE, {experienceYears.LINUX_START_DATE} years GNU/Linux professional/hobbyist.</li>
          </ul>
        </div>
      </section>
      <section className="hero">
        <div className="container">
          <div className="hero-buttons">
            <Link to="/blog" className="btn btn-secondary">
              read my blog
            </Link>
            <a href="/resume.pdf" className="btn btn-secondary">
              get my resume
            </a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;
